import { render } from "./Three_js.vue?vue&type=template&id=46b46f68&ts=true"
import script from "./Three_js.vue?vue&type=script&lang=ts"
export * from "./Three_js.vue?vue&type=script&lang=ts"

import "./Three_js.vue?vue&type=style&index=0&id=46b46f68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__